import { Injectable } from '@angular/core';

@Injectable()
export class StorageProvider {
  constructor() {}

  // Clear Session
  ////////////////

  _clearSessionData(id?:string) {
    if (id) {
      // Remove the specific task from session storage
      sessionStorage.removeItem(this._flattenQueryToString({ getTask: { id } }));
    }

    // Remove all task-list-related queries from session storage
    Object.keys(sessionStorage).forEach((key:string) => {
      if (key.indexOf("postTaskListForUser") !== -1 || key.indexOf("getTasks") !== -1 || key.indexOf("hasInvoice") !== -1) {
        sessionStorage.removeItem(key);
      }
    });

    // This allows fresh data to be pulled from the server for the next request, 
    // ensuring that the user sees the most up-to-date information for the selected task and the task list.
  }


  // Caching task data
  ////////////////////

  _flattenQueryToString(params: any) {

    // String Query
    ///////////////
    if (params && params?.getTasks?.filters?.completedDate && params?.getTasks?.filters?.completedDate?._gt) {
      params.getTasks.filters.completedDate._gt = new Date(params.getTasks.filters.completedDate._gt).setHours(0, 0, 0, 0);
    }
    if (params && params?.getTasks?.filters?.completedDate && params?.getTasks?.filters?.completedDate?._lt) {
      params.getTasks.filters.completedDate._lt = new Date(params.getTasks.filters.completedDate._lt).setHours(23, 59, 59, 999);
    }

    return JSON.stringify(params);
  }

  _flattenDataToString(data: any) {

    // Add anchors to determine data types
    //////////////////////////////////////

    if (Array.isArray(data)) {
      // isArray
      data = { __isArray: true, value: data };
      data.map((item:any, index:number) => {
        data.value[index] = this._flattenDataToString(item);
      });
      return data;

    }
    else if (typeof(data) === 'object' && !Array.isArray(data) && data !== null) {
      // isObject
      data = { __isObject: true, ...data };
      Object.keys(data).forEach(key => {
        data[key] = this._flattenDataToString(data[key]);
      });
      return data;

    }
    else if (typeof(data) === 'string') {
      // isString
      return data = { __isString: true, value: data };

    }
    else if (typeof(data) === 'number') {
      // isNumber
      return data = { __isNumber: true, value: data };

    }
    else if (typeof(data) === 'boolean') {
      // isBoolean
      return data = { __isBoolean: true, value: data };
    }

    return JSON.stringify(data);
  }

  _unflattenDataFromString(data: any) {
    if (data) {
      data = JSON.parse(data);

      if (data === null) {
        return "notFound";
      }
      
      if (data.__isArray) {
        // isArray
        const array = data.value;
        for (let i = 0; i < array.length; i++) {
          array[i] = this._unflattenDataFromString(array[i]);
        }
        return array;

      }
      else if (data.__isObject) {
        // isObject
        delete data.__isObject;
        Object.keys(data).forEach(key => {
          data[key] = this._unflattenDataFromString(data[key]);
        });
        return data;

      }
      else if (data.__isString) {
        // isString
        return data.value;

      }
      else if (data.__isNumber) {
        // isNumber
        return data.value;

      }
      else if (data.__isBoolean) {
        // isBoolean
        return data.value;
      }

      return data;

    } else {
      return null;
    }
  }

  setQueryData(params: any) {
    const flattenQueryToString = this._flattenQueryToString(params);
    sessionStorage.setItem(flattenQueryToString, JSON.stringify({ waiting: true }));
    setTimeout(() => {
      sessionStorage.removeItem(flattenQueryToString);
    }, 30000); 
  }

  hasQueryBeenCalledBefore(params: any, retry?: number) {
    const cachedData = this.getCachedQueryData(params);
    if (cachedData) {
      if (cachedData.waiting) {
        if (retry && retry > 5) {
          return [];
        }

        setTimeout(() => {
          this.hasQueryBeenCalledBefore(params, retry ? retry + 1 : 1);
        }, 1000);

      } else {
        return cachedData;
      }
    } else {
      this.setQueryData(params);
      return false;
    }
  }

  getCachedQueryData(params: any): any {
    const flattenQueryToString = this._flattenQueryToString(params);
    let cachedData = sessionStorage.getItem(flattenQueryToString);
    return cachedData ? this._unflattenDataFromString(cachedData) : null; 
  }
  
  setCachedQueryData(params: any, data: any) {
    const flattenQueryToString = this._flattenQueryToString(params);
    sessionStorage.setItem(flattenQueryToString, JSON.stringify(data));
    setTimeout(() => {
      sessionStorage.removeItem(flattenQueryToString);
    }, 30000);
  }
}



// WEBPACK FOOTER //
// ./src/providers/utils/storage.ts